module.exports = __webpack_public_path__ + "static/logo-48a954b785ecf930de4c5cdaa54c92a2.svg";